import type { NativeStackScreenProps } from '@react-navigation/native-stack'
import { RootStackParamList as Farmer360StackParamList } from '../farmer360/routes/types'

export enum ROUTES {
  DASHBOARD = 'Dashboard',
  REQUEST_TYPE = 'RequestType',
  PRICE_REQUEST = "PriceRequest",
  DEMO_MATERIAL_REQUEST = 'DemoMaterialRequest',
  NEW_REQUEST = "NewRequest",
  CHANGE_PRICE= "ChangePrice",
  REQUEST_SUCCESS ="RequestSucess",
  DEMO_NEW_REQUEST = 'DemoNewRequest',
  DEMO_PRODUCT_SELECTION = 'DemoProductSelection',
  DEMO_CREATE_REQUEST = 'DemoCreateRequest',
  DEMO_REVIEW_REQUEST = 'DemoReviewRequest',
  DEMO_REQUEST_DETAIL = 'DemoRequestDetail',
}

export type DemoDraftRequest = {
  vendor_id?: number
  vendor_name?: string
  dc_state_id?: number
  partner_id?: string
  node_name?: string
  inventory_node_name?: string
  partner_location?: string
  partner_address?: string
  product_variant_id: number
  product_brand?: string
  product_name?: string
  product_variant_label?: string
  product_image?: string | null
  units: number
  farmer_name: string
  farmer_mobile: string
  address: string
  pin_code: string
  state_id: number
  district_id: number
  block_id: number
  village_id: number
  state_name?: string
  district_name?: string
  block_name?: string
  village_name?: string
  crop_id?: number
  crop_name?: string
  inventory_node_id?: number
  remarks?: string
}

export type RootStackParamList = {
  [ROUTES.DASHBOARD]: undefined
  [ROUTES.REQUEST_TYPE]: undefined
  [ROUTES.PRICE_REQUEST]: {
    resetFilters?: boolean
  };
  [ROUTES.DEMO_MATERIAL_REQUEST]: {
    resetFilters?: boolean
  };
  [ROUTES.NEW_REQUEST]: undefined;
  [ROUTES.CHANGE_PRICE]: undefined
  [ROUTES.REQUEST_SUCCESS]: {
    flow?: 'PRICE_CHANGE' | 'DEMO_MATERIAL'
    requestId?: number
  } | undefined
  [ROUTES.DEMO_NEW_REQUEST]: undefined
  [ROUTES.DEMO_PRODUCT_SELECTION]: undefined
  [ROUTES.DEMO_CREATE_REQUEST]: {
    draft: Omit<
      DemoDraftRequest,
      | 'farmer_name'
      | 'farmer_mobile'
      | 'address'
      | 'pin_code'
      | 'state_id'
      | 'district_id'
      | 'block_id'
      | 'village_id'
    >
  }
  [ROUTES.DEMO_REVIEW_REQUEST]: {
    draft: DemoDraftRequest
  }
  [ROUTES.DEMO_REQUEST_DETAIL]: {
    requestId: number
  }
} & Farmer360StackParamList

export type DashboardScreenProps = NativeStackScreenProps<
  RootStackParamList,
  ROUTES.DASHBOARD
>
export type PriceRequestScreenProps = NativeStackScreenProps<
  RootStackParamList,
  ROUTES.PRICE_REQUEST
>;
export type DemoMaterialRequestScreenProps = NativeStackScreenProps<
  RootStackParamList,
  ROUTES.DEMO_MATERIAL_REQUEST
>;
export type NewRequestScreenProps = NativeStackScreenProps<
  RootStackParamList,
  ROUTES.NEW_REQUEST
>;
export type ChangePriceScreenProps = NativeStackScreenProps<
  RootStackParamList, 
  ROUTES.CHANGE_PRICE
>;
export type RequestSucessScreenProps = NativeStackScreenProps<
  RootStackParamList, 
  ROUTES.REQUEST_SUCCESS
>;
export type DemoNewRequestScreenProps = NativeStackScreenProps<
  RootStackParamList,
  ROUTES.DEMO_NEW_REQUEST
>;
export type DemoProductSelectionScreenProps = NativeStackScreenProps<
  RootStackParamList,
  ROUTES.DEMO_PRODUCT_SELECTION
>;
export type DemoCreateRequestScreenProps = NativeStackScreenProps<
  RootStackParamList,
  ROUTES.DEMO_CREATE_REQUEST
>;
export type DemoReviewRequestScreenProps = NativeStackScreenProps<
  RootStackParamList,
  ROUTES.DEMO_REVIEW_REQUEST
>;
export type DemoRequestDetailScreenProps = NativeStackScreenProps<
  RootStackParamList,
  ROUTES.DEMO_REQUEST_DETAIL
>;
